import '../css'
import jstz from 'jstz'
import '@nathanvda/cocoon'

$(function() {
  if (!$('meta[name="timezone"]').attr('content')) {
    const timezone = jstz.determine()
    $.post('/timezone', { _method: 'put', timezone: timezone.name() })
  }
})
